import { useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export const QUEUE_MARK = "/brand/the-queue-Q-mark-transparent-512.png";
export const QUEUE_MARK_WHITE = "/brand/the-queue-Q-mark-white-transparent-1024.png";
const DARK_BACKGROUND_THEMES = new Set();

export const SiteFooter = () => {
  const { pathname } = useLocation();
  const { theme } = useApp();
  const mark = DARK_BACKGROUND_THEMES.has(theme) ? QUEUE_MARK_WHITE : QUEUE_MARK;
  const year = new Date().getFullYear();
  return (
    <footer className={`border-t border-border/70 bg-background ${pathname.startsWith("/admin") ? "lg:pl-64" : ""}`} data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 text-[11px] leading-relaxed text-muted-foreground sm:px-6 md:flex-row md:items-start md:justify-between lg:px-10">
        <div className="min-w-0 space-y-1.5 md:max-w-3xl">
          <p data-testid="footer-copyright">© {year} Root Equity Partners. All rights reserved.</p>
          <div data-testid="footer-trademarks">
            <p data-testid="footer-trademark-rep">Root Equity Partners™ and the Root Equity Partners logo are trademarks of Root Equity Partners.</p>
            <p data-testid="footer-trademark-queue">The Queue™ and The Queue logo are trademarks of The Queue.</p>
            <p data-testid="footer-trademark-others">All other trademarks are the property of their respective owners.</p>
          </div>
          <p className="flex flex-wrap gap-x-4">
            <a href="#privacy" onClick={(e) => e.preventDefault()} className="underline-offset-4 hover:text-foreground hover:underline" data-testid="footer-privacy-link">Privacy Policy</a>
            <a href="#terms" onClick={(e) => e.preventDefault()} className="underline-offset-4 hover:text-foreground hover:underline" data-testid="footer-terms-link">Terms of Use</a>
          </p>
        </div>
        <a href="https://the-queue.com" target="_blank" rel="noopener noreferrer" data-testid="footer-powered-by"
          className="inline-flex shrink-0 items-center gap-2 self-start opacity-80 transition-opacity hover:opacity-100">
          <img src={mark} alt="The Queue" width="20" height="20" className="h-5 w-5 object-contain" draggable={false} data-testid="footer-queue-mark" />
          <span className="whitespace-nowrap font-medium">Powered by The Queue</span>
        </a>
      </div>
    </footer>
  );
};
